import axios from "axios";
import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";

const token = localStorage.getItem("session")
  ? JSON.parse(localStorage.getItem("session")).token
  : null;

export const signUp = (user) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_SIGNUP_INFO",
      loader: true,
    });
    axios
      .post(`${url}/v1/auths/register`, user)
      .then((session) => {
        localStorage.setItem("session", JSON.stringify(session.data));
        dispatch({
          type: "SIGN_UP",
          session: JSON.stringify(session.data),
        });
        dispatch({
          type: "SENDING_SIGNUP_INFO",
          loader: false,
        });
        window.location.reload(false);
      })

      .catch((error) => {
        dispatch({
          type: "SENDING_SIGNUP_INFO",
          loader: false,
        });
        dispatch({
          type: "SIGNUP_FAILED",
          message: navigator.onLine
            ? "Failed to register user"
            : "Network error ",
        });
      });
  };
};

export const signIn = (creds) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_LOGIN_INFO",
      loader: true,
    });
    axios
      .post(`${url}/v1/auths/login`, creds)
      .then((session) => {
        localStorage.setItem("session", JSON.stringify(session.data));
        dispatch({
          type: "SIGN_IN",
          session: JSON.stringify(session.data),
        });
        dispatch({
          type: "SENDING_LOGIN_INFO",
          loader: false,
        });
        window.location.reload(false);
      })
      .catch((response) => {
        dispatch({
          type: "SENDING_LOGIN_INFO",
          loader: false,
        });
        dispatch({
          type: "LOGIN_FAILED",
          message: navigator.onLine
            ? "Wrong user credentials"
            : "Network error",
        });
      });
  };
};

export const updatePassword = (updatedPasswordInfo, id) => {
  return (dispatch) => {
    axios
      .put(`${url}/auths/update-password/${id}`, updatedPasswordInfo, {
        headers: header,
      })
      .then((message) => {
        dispatch({
          type: "UPDATE_PASSWORD",
          message,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to update password", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};

export const tokenValidation = () => {
  return (dispatch) => {
    axios
      .post(`${url}/v1/auths/check-token-validity`, {
        token: `Bearer ${token}`,
      })
      .then((valid) => {})
      .catch((error) => {
        if (token != null && navigator.onLine) {
          dispatch({
            type: "SIGN_OUT",
          });
        }
      });
  };
};

export const loadUser = () => {
  return (dispatch, getState) => {
    const session = getState().auth.session;
    if (session) {
      dispatch({
        type: "USER_LOADED",
        session,
      });
    } else return null;
  };
};

export const signOut = () => {
  return (dispatch) => {
    dispatch({
      type: "SIGN_OUT",
    });
  };
};
